<template>
  <b-modal
    id="cms-create-promotion"
    title="New Promotion"
    no-close-on-backdrop
    size="lg"
    @ok="onOk"
  >
    <ValidationObserver ref="cmsForm" v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          v-slot="{ errors }"
          name="title"
          :rules="{
            required: true,
          }"
        >
          <b-form-group label="Title">
            <b-form-input
              id="title"
              v-model="createPromotionForm.title"
              :state="errors[0] ? false : null"
            ></b-form-input>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="image_src"
          :rules="{
            required: true,
          }"
        >
          <b-form-group label="Image">
            <CmsFileSelect
              :value="createPromotionForm.imageSrc"
              :state="errors[0] ? false : null"
              @update="(value) => (createPromotionForm.imageSrc = value || '')"
            />
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="image_src"
          :rules="{
            required: false,
          }"
        >
          <b-form-group label="Content">
            <vue-editor
              v-model="createPromotionForm.content"
              :state="errors[0] ? false : null"
            />
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="position"
          :rules="{
            required: true,
          }"
        >
          <b-form-group label="Position">
            <b-form-input
              id="position"
              v-model="createPromotionForm.position"
              :state="errors[0] ? false : null"
            ></b-form-input>
          </b-form-group>
        </ValidationProvider>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { VueEditor } from 'vue2-editor'

export default {
  components: {
    CmsFileSelect: () => import('../file-select.vue'),
    VueEditor,
  },
  data() {
    return {
      createPromotionForm: {
        position: 0,
        title: '',
        imageSrc: '',
        content: '',
      },
    }
  },
  computed: {
    ...mapState({
      isCreatingSiteBanners: (state) => state.cms.isCreatingSiteBanners,
    }),
    ...mapGetters(['siteId']),
  },
  methods: {
    ...mapActions(['createCmsPromotions']),
    async onOk(e) {
      e.preventDefault()
      const valid = await this.$refs.cmsForm.validate()
      if (valid) {
        this.onSubmit(() => this.$bvModal.hide('cms-create-promotion'))
      }
    },
    async onSubmit(cb) {
      await this.createCmsPromotions({
        siteId: this.siteId,
        promotions: [this.createPromotionForm],
      })

      cb()
    },
  },
}
</script>
